import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { BaseCommonComponent, BaseDataService, ConfirmationDialogButtons, ErrorHandlerService, ModalService, ModelData, NotificationService, QueryParameter } from "yt-ng-framework";
import { Attachment } from "./attachment";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { translate } from "@angular/localize/src/utils";
import { HttpErrorResponse } from "@angular/common/http";
import { FormGroup, Validators } from "@angular/forms";
import { EOtpremnica } from "../eotpremnica/eotpremnica";

@Component({
    selector: 'yt-promena-vozila',
    templateUrl: './promena-vozila.component.html'
})
export class PromenaVozilaComponent implements OnInit{
    @Input() Parameters;
    modelData: ModelData;
    Config={};
    items: Attachment[] = [];
    submitted = false;  
    files: any[] = [];
    messages: string[] = [];
    filesLength: any;
    filesCount: any;
    loadingSendPromenaVozila: boolean = false;
    get fc() { return this.baseFormGroup.controls; }
    public baseFormGroup: FormGroup = new FormGroup({});
    @ViewChild('ytImeVozaca', {static: false}) ytImeVozaca: Input;
    @ViewChild('ytPrezimeVozaca', {static: false}) ytPrezimeVozaca: Input;
    @ViewChild('ytEmailVozaca', {static: false}) ytEmailVozaca: Input;
    @ViewChild('ytTelefonVozaca', {static: false}) ytTelefonVozaca: Input;
    @ViewChild('ytRegistarskiBrojPrevoznika', {static: false}) ytRegistarskiBrojPrevoznika: Input;
    @ViewChild('ytVozacBrojVozackeDozvole', {static: false}) ytVozacBrojVozackeDozvole: Input;


    constructor(
        protected activeModal: NgbActiveModal,
        protected baseDataService: BaseDataService,
        protected translateService: TranslateService,
        protected toastrService: NotificationService,
        protected modalService: ModalService,
        protected errorService: ErrorHandlerService
      ) {}
    
    // ImeVozaca: string=null;
    // PrezimeVozaca: string=null;
    // TelefonVozaca: string=null;
    // EmailVozaca: string=null;
    // RegistarskiBrojPrevoznika: string=null;
    // BrojLicneKarte: string=null;

    // Deserialize(input: any){            
    //     this.ImeVozaca=input.ImeVozaca;
    //     this.PrezimeVozaca=input.PrezimeVozaca;
    //     this.EmailVozaca=input.EmailVozaca;
    //     this.TelefonVozaca=input.TelefonVozaca;
    //     this.RegistarskiBrojPrevoznika=input.RegistarskiBrojPrevoznika;
    //     this.BrojLicneKarte=input.BrojLicneKarte;
    //     return this;
    // }

 
//ngOnInit():void {
      ngOnInit() {
        // this.files = [];
        // this.filesLength = 0;
        // this.filesCount = 0;
        
      }
    

      OsveziListu(){
        this.Config={
        EditIcon: {
            Visible: false
        },
        DeleteIcon: {
            Visible: true
        },
        DefaultSortKey: this.modelData.MainList.SortBy,
        DefaultSortReverse: this.modelData.MainList.SortReverse,
        ShowIndex: false,
        ShowDefaultListButtons: false,
        ShowCheckBoxes: false,
        PrintIcon: {
            Visible: false
        }
        ,BreadCrumble: this.modelData.BreadcrumbLabel
        ,Height: 'auto'
        }
    }

      PromenaVozila(){
        this.submitted = true;

        // if (this.ytImeVozaca.Value == null)
        //   return false;

        this.loadingSendPromenaVozila=true;
      
        let parameters = {
            eOtpremnicaID: this.Parameters[0].Value
            ,masterDokumID: this.Parameters[1].Value
        };    

        // this.baseDataService.GetFile('EOtpremnica','PromenaVozila',parameters)
        //     .subscribe((result : any) => {
        //         this.loadingSendPromenaVozila = false;
        //         this.translateService.get(["EOTPREMNICA.PROMENAVOZILA.SUCESS"])
        //         .subscribe(translate => {
        //             this.toastrService.success(translate["EOTPREMNICA.PROMENAVOZILA.SUCESS"]);
        //             this.activeModal.close(true);
        //         })
        //     }
            // ,error => {
            //     this.loadingSendPromenaVozila=false;
            //     let _message;
            //     let translatedMessage: string = "";
            //     if(error instanceof HttpErrorResponse){
            //         _message = this.errorService.getServerMessage(error);
            //         if (_message instanceof ArrayBuffer){
            //         _message = new TextDecoder('utf-8').decode(new Uint8Array(_message));
            //         let message: string = _message;
            //         if (message.includes("EDOKUMENT")){
            //             let messageArray: string[] = message.split(';');   
            //             messageArray.forEach((element, index) => {
            //             messageArray[index] = "FW.ERRORS." + element;
            //             });
            //             this.translateService.get(messageArray)
            //             .subscribe(translate => {
            //             translatedMessage = Object.keys(translate).map(key => translate[key]).join('\r\n');
            //             });
            //         }
            //         else
            //             translatedMessage = message;              
            //         }
            //         else{
            //         translatedMessage = this.errorService.getClientMessage(error);
            //         }
            //     }
            //     this.modalService.ShowConfirmationDialog("Problemi kod slanja promene vozila", translatedMessage, "warning", ConfirmationDialogButtons.Ok);
            // })
            this.baseDataService.GetByID('EOtpremnicaPrevoz',parameters.eOtpremnicaID,EOtpremnica)
        .subscribe((result: EOtpremnica) => {
          this.loadingSendPromenaVozila = false;
          imeVozaca : this.ytImeVozaca; 
          prezimeVozaca : this.ytPrezimeVozaca;
          emailVozaca : this.ytEmailVozaca;
          telefonVozaca : this.ytTelefonVozaca;
          registarskiBrojPrevoznika : this.ytRegistarskiBrojPrevoznika;
          vozacBrojVozackeDozvole : this.ytVozacBrojVozackeDozvole;
        })
      //.Save())
      }

      Close(){
        this.activeModal.dismiss();
      }    
}